// extracted by mini-css-extract-plugin
export default {"contents":"EF-z","sectionHeading":"FF-z"};